import * as React from "react";
const IconMenuCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M60 31H4c-.6 0-1 .4-1 1s.4 1 1 1h56c.6 0 1-.4 1-1s-.4-1-1-1M60 48.1H4c-.6 0-1 .4-1 1s.4 1 1 1h56c.6 0 1-.4 1-1s-.4-1-1-1M4 15.9h56c.6 0 1-.4 1-1s-.4-1-1-1H4c-.6 0-1 .4-1 1s.4 1 1 1" />
  </svg>
);
export default IconMenuCopy;
